import { createTheme } from "@mui/material/styles";

const lightPalette = {
  mode: "light",
  primary: {
    main: "#17355F",
    light: "#DDEBFF",
  },
  secondary: {
    main: "#1a73e8",
  },
  background: {
    default: "#f5f7fb",
    paper: "#ffffff",
  },
  text: {
    primary: "#1b1e36",
    secondary: "#5f6a7d",
    main: "#394149",
  },
};

const darkPalette = {
  mode: "dark",
  primary: {
    main: "#7aa6ff",
  },
  secondary: {
    main: "#8ab4ff",
  },
  background: {
    default: "#0f172a",
    paper: "#111c30",
  },
  text: {
    primary: "#f8fbff",
    secondary: "#cbd5f5",
    main: "#394149",
  },
};

const baseTypography = {
  fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  h5: {
    fontWeight: 600,
  },
  h6: {
    fontWeight: 600,
  },
  subtitle1: {
    fontWeight: 500,
  },
};

const createAppTheme = (mode = "light", language = "ar") =>
  createTheme({
    direction: language === "ar" ? "rtl" : "ltr", // Dynamically set direction
    palette: mode === "light" ? lightPalette : darkPalette,
    shape: {
      borderRadius: 10,
    },
    typography: {
      ...baseTypography,
      body2: {
        color:
          mode === "light"
            ? lightPalette.text.secondary
            : darkPalette.text.secondary,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          // MUI's icon margins are physical (left/right). Flip them for RTL
          // so Arabic labels keep the same readable gap as LTR labels.
          startIcon: {
            marginRight: language === "ar" ? -4 : 8,
            marginLeft: language === "ar" ? 8 : -4,
          },
          endIcon: {
            marginRight: language === "ar" ? 8 : -4,
            marginLeft: language === "ar" ? -4 : 8,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 20,
          },
        },
      },
    },
  });

export default createAppTheme;
